import React from 'react'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import { Logo } from '@pepsico-ds/ui'

function Loader({ isLoading = true }) {
  return (
    <Backdrop open={isLoading} className="loader-backdrop">
      <Box className="loader-box" data-testid="loader">
        <div className="logo-container">
          <Logo logoType="pepsicoFullLogo" />
          <Box className="loading-wave" />
        </div>
      </Box>
    </Backdrop>
  )
}

export default Loader
